import { BaseSerializer } from "./baseSerializer.ts";
import {Todo} from "@models/todo.model.ts";
import {EmployeeSerializer} from "@models/serializers/employeeSerializer.ts";


export class TodoSerializer extends BaseSerializer {

    public deserialize( data: any ): Todo {

        const todo = new Todo();
        this._copyAttributes(todo, data);

        if (data.assigned_to) {
            const employeeSerializer = new EmployeeSerializer();
            todo.assigned_to = employeeSerializer.deserialize(data.assigned_to);
        }

        return todo;
    }

}
